import { useTheme } from '@/contexts/ThemeContext';

export const useIsModern = () => useTheme().design === 'modern';

export const DECOR_TYPES = ['door', 'bathroom', 'divider', 'bar', 'bar_counter', 'planta', 'banqueta', 'ducha', 'pasarela', 'pared', 'fondo'];
export const isDecor = (u) => DECOR_TYPES.includes(u?.unit_type);

export const DECOR_PALETTE = [
  ['planta', 'Planta'], ['bar', 'Barra'], ['banqueta', 'Banquetas'], ['bathroom', 'Baño'], ['door', 'Puerta'],
  ['pared', 'Pared'], ['ducha', 'Duchas'], ['pasarela', 'Pasarela'],
];

export const TEXTURES = [
  ['madera', 'Madera'], ['ceramica', 'Cerámica'], ['cemento', 'Cemento'], ['arena', 'Arena'], ['cesped', 'Césped'], ['mar', 'Mar'],
];

export const FORMAS = [['cuadrada', 'Cuadrada'], ['redonda', 'Redonda'], ['rectangular', 'Rectangular'], ['sombrilla', 'Sombrilla'], ['carpa', 'Carpa']];

// Medios de pago visibles: Transferencia / QR Morphyng queda deshabilitado hasta que exista
export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Efectivo' },
  { value: 'debit', label: 'Débito' },
  { value: 'credit', label: 'Crédito' },
  { value: 'transfer', label: 'Transferencia / QR Morphyng', disabled: true, note: 'Próximamente' },
];
export const methodLabel = (m) => ({ cash: 'Efectivo', debit: 'Débito', credit: 'Crédito', card: 'Tarjeta', transfer: 'Transferencia' }[m] || m);

// Versión liviana de una foto (Unsplash/Pexels por parámetro; archivos propios por ?size=sm)
export const thumbUrl = (url, w = 480) => {
  if (!url) return url;
  if (url.includes('images.unsplash.com')) return url.replace(/([?&])w=\d+/, `$1w=${w}`).replace(/([?&])q=\d+/, '$1q=60');
  if (url.includes('images.pexels.com')) return url.replace(/([?&])w=\d+/, `$1w=${w}`);
  if (url.startsWith('/api/files/')) return `${url}${url.includes('?') ? '&' : '?'}size=sm`;
  return url;
};

export const shortName = (name = '') => name.replace(/^(Mesa|Sombrilla|Carpa VIP|Carpa)\s+/i, '') || name;

export const fmtElapsed = (iso, now = Date.now()) => {
  if (!iso) return '';
  const mins = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 60000));
  return `${Math.floor(mins / 60)}:${String(mins % 60).padStart(2, '0')}`;
};
